import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Warehouse } from 'lucide-react';

const KellerDachbodenDortmund = () => {
  return (
    <ServiceTemplate
      title="Keller & Dachboden Entrümpelung in Dortmund"
      slug="keller-dachboden-entruempelung-dortmund"
      icon={Warehouse}
      intro="Professionelle Entrümpelung von Kellern, Dachböden und Garagen in Dortmund. Auch bei schwierigen Zugängen, engen Treppen oder großen Mengen. Wir sortieren, tragen ab und entsorgen fachgerecht. Kostenfreie Einschätzung per Foto möglich."
      whatIncluded="Komplette Räumung von Kellerräumen, Dachböden, Garagen oder Abstellräumen. Wir tragen alles ab – auch bei engen Treppen oder niedrigen Decken. Verwertbares wird getrennt, Rest fachgerecht entsorgt. Besenrein."
      whenNeeded="Ideal vor Hausverkauf, Renovierung, bei Platzproblemen oder geerbten Immobilien. Auch wenn Sie selbst nicht mehr die Kraft haben, jahrelang angesammelte Gegenstände zu sortieren und zu entsorgen."
      pricing="Je nach Größe und Füllgrad: Kleiner Keller 400–800 €, großer Keller 800–1.500 €, Dachboden 600–1.200 €, Garage 300–600 €. Kombinationen erhältlich. Schwierige Zugänge werden einkalkuliert. Dauer: meist 3–6 Stunden."
      valueCredit="Oft finden sich auf Dachböden und in Kellern wertvolle Gegenstände: alte Möbel, Werkzeuge, Sammlungen. Diese werden angerechnet und reduzieren Ihren Preis."
      disposal="Sortenreine Entsorgung: Altholz, Metall, Elektroschrott, Restmüll. Sondermüll wie alte Farben oder Chemikalien werden separat entsorgt. Alles gesetzeskonform und dokumentiert."
    />
  );
};

export default KellerDachbodenDortmund;